import React from 'react';
import { useOrganization } from '@clerk/clerk-react';
import DecimalConventionField from 'modules/Common/form/v2/fields/DecimalConventionField';
import { useTranslation } from 'react-i18next';
import LanguageField from 'modules/Common/form/v2/fields/LanguageField';
import { isLanguageSelectionAllowed } from 'modules/Common/config/languageAccess';

// Renders the user/device-scoped organization preferences. Lives as its own
// tab in the Clerk OrganizationProfile so the role-specific Info forms (which
// post to our backend) stay focused on org metadata.
export default function OrganizationPreferences() {
  const { t } = useTranslation('common');
  const { organization } = useOrganization();
  // Operators/consultants are pinned to English (see languageAccess), so the
  // field would be a control with no effect — drop it rather than disable it.
  const canPickLanguage = isLanguageSelectionAllowed(organization?.publicMetadata?.type);

  return (
    <div className="flex flex-col gap-2 mt-1">
      <h1>{t('preferences.title', 'Preferences')}</h1>
      <p className="text-sm text-slate-500 mb-3">
        {t(
          'preferences.subtitle',
          'Display options for this device. Changes apply immediately and are saved locally.',
        )}
      </p>
      <div className="grid grid-cols-12 gap-4">
        {canPickLanguage && <LanguageField colSpan={6} />}
        <DecimalConventionField colSpan={6} />
      </div>
    </div>
  );
}
